// extracted by mini-css-extract-plugin
module.exports = {"stripe-payment-button":"stripe-payment-button__HXQXz"};